import { createEvent } from 'effector'

/**
 * Trggered once, on app start
 */
export const initializeApp = createEvent('initialize app')
